import { useSelector } from 'react-redux';

export const useCanSingleSendMessage = (): boolean => {
  const access = useSelector((s: any) => s.authentication.access);

  return access?.contacts?.single_record_actions?.single_send_message ?? false;
};
